module.exports = __webpack_public_path__ + "static/media/artwork.7772bc31.png";